export default {
  box: {
    width: '100%',
    height: '100%',
    paddingBottom: '4em',
    margin: '0 16px 0 16px',
  },
  image: {
    borderRadius: '1em',
    overflow: 'hidden',
  },
  imageMobile: {
    objectFit: 'contain',
  },
  headline: {
    width: '100%',
    padding: '2em 3em',
    textAlign: 'center',
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  action: {
    marginBottom: '1em',
    width: '100%',
  },
  actionLink: {
    width: '100%',
  },
  optionalLink: {
    textAlign: 'center',
  },
};
